import { render, staticRenderFns } from "./SwitchAppointment.vue?vue&type=template&id=2ca8d664&"
import script from "./SwitchAppointment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchAppointment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca8d664')) {
      api.createRecord('2ca8d664', component.options)
    } else {
      api.reload('2ca8d664', component.options)
    }
    module.hot.accept("./SwitchAppointment.vue?vue&type=template&id=2ca8d664&", function () {
      api.rerender('2ca8d664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchAppointment/SwitchAppointment.vue"
export default component.exports